import { App } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { ApiError } from '@/services/api/client';
import * as notificationsApi from '@/services/api/notifications';

export function useNotificationUnreadCount() {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const result = await notificationsApi.fetchUnreadCount();
      setCount(result.count);
    } catch (error) {
      const text = error instanceof ApiError ? error.message : '加载未读消息失败';
      message.error(text);
      setCount(0);
    } finally {
      setLoading(false);
    }
  }, [message]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { loading, count, reload };
}
